import React from 'react';
import SearchTransfer from '../components/SearchContent/Transfers/SearchTransfer';
import { translate } from 'react-i18next';
import ExclusiveFormLandscape from '../components/SearchContent/ExclusiveFormLandscape';
import { getUserInformation } from '../components/Login/loginService';
import { Typography } from 'material-ui';
import LandscapeSearchTransfer from '../components/SearchContent/Transfers/LandscapeSearchTransfer';
import SearchFormLandscape from '../components/SearchContent/SearchFormLandscape';
import { getCMSConfiguration } from './../cms/cmsLib';
import {dataService} from './SearchTabs';
import { connect } from 'react-redux';

import { setHotelsTab } from '../actions/tabActions';

class SearchFormTabsLandscape extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentHash: '',
            reduxSelectedTab: {}
        };

        this.currentUser = getUserInformation();
    }
    componentDidMount() {

        window.addEventListener('hashchange', this.checkHash, false);
        this.checkHash();
        // Subscriber to know the current selected tab
        dataService.getData().subscribe(value => {
            this.selectedTab = value.tab;
        });
    }

    componentDidUpdate() {
        if ( Object.entries(this.props.reduxSelectedTab).length > 0 ) {
            this.selectedTab = {...this.props.reduxSelectedTab};
        }
    }

    componentWillUnmount() {
        window.removeEventListener('hashchange', this.checkHash, false);
    }

    checkHash = () => {
        //esto es mas flojito que gago pero bueno.
        let hash = window.location.hash;
        hash = hash.replace(/\?.+/, '');
        let page = hash.split('/')[2];
        page = unescape(page);
        //http://localhost:3006/#/buscar/form1
        this.setState({ currentHash: page });
    }
    render() {

        // load the default tab if none is selected
        if (!this.selectedTab) {
            let cmsConf = getCMSConfiguration();
 
            // in the results page, we dont know the selected tab, so we have it saved in the local storage
            if (localStorage.getItem('selectedTab') && localStorage.getItem('selectedTab') !== 'undefined') {
                let currentSelectedTab = JSON.parse(localStorage.getItem('selectedTab'));
                this.selectedTab = cmsConf['tabs'].find(x => x.orden === Number(currentSelectedTab.orden));
            } else {
                this.selectedTab = cmsConf['tabs'].find(x => x.orden === Number(this.state.currentHash));
                this.selectedTab ? localStorage.setItem('selectedTab', JSON.stringify(this.selectedTab)) : null;
            }
        }

        // It fills up when there are params in the search nav.
        if ( Object.entries(this.props.reduxSelectedTab).length > 0 ) {
            this.selectedTab = {...this.props.reduxSelectedTab};
        }

        return <div className="cmsSearchFormTabs">
            {this.selectedTab && this.selectedTab.type.id === 'H' ? <SearchFormLandscape user={this.currentUser} tab={this.selectedTab} searchFormType={'H'}/> : ''}
            {this.selectedTab && this.selectedTab.type.id === 'T' ? <LandscapeSearchTransfer user={this.currentUser}/> : ''}
            {this.selectedTab && this.selectedTab.type.id === 'DS' ? <SearchFormLandscape user={this.currentUser} tab={this.selectedTab} searchFormType={'DS'}/> : ''}
            {this.selectedTab && this.selectedTab.type.id === 'HS' ? <SearchFormLandscape user={this.currentUser} tab={this.selectedTab} searchFormType={'HS'}/> : ''}
        </div>;
    }
}

const mapStateToProps = state => ({
    reduxSelectedTab: state.tabsRedux.selectedTab
});

export default connect(mapStateToProps)(SearchFormTabsLandscape);


// WEBPACK FOOTER //
// ./src/cms/SearchFormTabsLandscape.js